<!-- Breadcrumb navigation -->
<div class="breadcrumb-container">
  <div class="breadcrumb-navigation">
    <span class="breadcrumb-item breadcrumb-current" *ngIf="user?.esColaborador; else AdminTemplate"
      >Home</span
    >
    <ng-template #AdminTemplate>
      <span
      class="breadcrumb-item breadcrumb-home"
      (click)="volver()"
      >Home</span
    >
    </ng-template>
    <i nz-icon nzType="right" class="breadcrumb-separator"></i>
    <span class="breadcrumb-item breadcrumb-current"
      >Reporte Resumen de Gastos Médicos Menores y Comprobaciones</span
    >
  </div>
</div>
<div class="boton-añadir-container">
  <button
    *ngIf="(this.user?.esColaborador || this.user?.esMedico) && NoAcceso"
    nz-button
    nzType="primary"
    class="excel-button boton-añadir"
    (click)="AddSolicitud()"
  >
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    Añadir Solicitud de Reembolso
  </button>
</div>
<nz-spin [nzSpinning]="isLoading" nzTip="Cargando..." class="loading-spinner">
<div class="center-container scroll-container">
  <div
    class="employee-cards-container"
    *ngIf="!user?.esColaborador; else TemplateColaborador"
  >
    <div class="employee-info-card">
      <div class="employee-main-info">
        <div class="info-row-horizontal">
          <div class="info-col">
            <span class="info-label-small">Nombre</span>
            <span class="info-value-large"
              >{{ DatosColaborador?.nombres }}
              {{ DatosColaborador?.apellidos }}</span
            >
          </div>
          <div class="info-col">
            <span class="info-label-small">Correo</span>
            <span class="info-value-large">{{
              DatosColaborador?.correoKof
            }}</span>
          </div>
        </div>

        <div class="info-row-four-cols">
          <div class="info-col-quarter">
            <span class="info-label-small">Género</span>
            <span class="info-value-large">{{
              DatosColaborador?.generoDescripcion
            }}</span>
          </div>
          <div class="info-col-quarter">
            <span class="info-label-small">Número de Empleado</span>
            <span class="info-value-large">{{
              DatosColaborador?.numeroEmpleado || "N/A"
            }}</span>
          </div>
        </div>

        <div class="info-row-four-cols">
          <div class="info-col-quarter">
            <span class="info-label-small">Fecha de Nacimiento</span>
            <span class="info-value-large">{{
              (DatosColaborador?.fechaNacimiento | date : "dd/MM/yyyy") || "N/A"
            }}</span>
          </div>
          <div class="info-col-quarter">
            <span class="info-label-small">División</span>
            <span class="info-value-large">{{
              DatosColaborador?.divisionNombre || "N/A"
            }}</span>
          </div>
          <div class="info-col-quarter">
            <span class="info-label-small">Sociedad</span>
            <span class="info-value-large">{{
              DatosColaborador?.sociedadNombre || "N/A"
            }}</span>
          </div>
          <div class="info-col-quarter">
            <span class="info-label-small">Fecha de Alta del Beneficio</span>
            <span class="info-value-large">{{
              (DatosColaborador?.fechaAltaBeneficio | date : "dd/MM/yyyy") ||
                "N/A"
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjeta de saldos separada -->
    <div class="salary-card">
      <div class="salary-table">
        <!-- Saldo Total Anual destacado -->
        <div class="salary-row salary-row-total salary-row-vertical">
          <div class="salary-label-total">Saldo Total Anual</div>
          <div class="salary-amount-total">
            {{
              (DatosColaborador?.saldoTotal | currency : "" : "symbol" : "1.2-2") || "-"
            }}
          </div>
        </div>

        <!-- Línea divisoria -->
        <hr class="salary-divider" />

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Comprobado</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoUtilizado | currency : "" : "symbol" : "1.2-2") || "-"
            }}
          </div>
        </div>

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Pendiente</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoRestante | currency : "" : "symbol" : "1.2-2") || "-"
            }}
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjeta de saldos gestante -->
    <div class="salary-card" *ngIf="DatosColaborador?.saldoRestanteGestante != undefined && DatosColaborador?.saldoUtilizadoGestante != undefined && DatosColaborador?.saldoTotalGestante != undefined">
      <div class="salary-table">
        <div class="salary-row salary-row-total salary-row-vertical">
          <div class="salary-label-total">Saldo Total Gestante</div>
          <div class="salary-amount-total">
            {{
              (DatosColaborador?.saldoTotalGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>

        <hr class="salary-divider" />

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Comprobado Gestante</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoUtilizadoGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Pendiente Gestante</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoRestanteGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>
      </div>
      <div class="leyenda-container">
      <span class="leyenda-texto">La Vigencia de saldo de bebés en gestación es de 9 meses a partir de su Fecha de Alta</span>
      </div>
    </div>
  </div>
  <ng-template #TemplateColaborador>
    <div class="employee-cards-container">
      <div class="employee-info-card">
        <div class="employee-main-info">
          <div class="info-row-horizontal">
            <div class="info-col">
              <span class="info-label-small">Nombre</span>
              <span class="info-value-large"
                >{{ DatosColaborador?.nombres }}
                {{ DatosColaborador?.apellidos }}</span
              >
            </div>
            <div class="info-col-quarter">
              <span class="info-label-small">Número de Empleado</span>
              <span class="info-value-large">{{
                DatosColaborador?.numeroEmpleado || "N/A"
              }}</span>
            </div>
          </div>

          <div class="info-row-four-cols">
            <div class="info-col-quarter">
              <span class="info-label-small">Fecha de Nacimiento</span>
              <span class="info-value-large">{{
                (DatosColaborador?.fechaNacimiento | date : "dd/MM/yyyy") ||
                  "N/A"
              }}</span>
            </div>
            <div class="info-col-quarter">
              <span class="info-label-small">Género</span>
              <span class="info-value-large">{{
                DatosColaborador?.generoDescripcion
              }}</span>
            </div>
          </div>

          <div class="info-row-four-cols">
            <div class="info-col-quarter">
              <span class="info-label-small">División</span>
              <span class="info-value-large">{{
                DatosColaborador?.divisionNombre || "N/A"
              }}</span>
            </div>
            <div class="info-col-quarter">
              <span class="info-label-small">Sociedad</span>
              <span class="info-value-large">{{
                DatosColaborador?.sociedadNombre || "N/A"
              }}</span>
            </div>
            <div class="info-col-quarter">
              <span class="info-label-small">Fecha de Alta del Beneficio</span>
              <span class="info-value-large">{{
                (DatosColaborador?.fechaAltaBeneficio | date : "dd/MM/yyyy") ||
                  "N/A"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="salary-card">
        <div class="salary-table">
          <div class="salary-row salary-row-total salary-row-vertical">
            <div class="salary-label-total">Saldo Total Anual</div>
            <div class="salary-amount-total">
              {{
                DatosColaborador?.saldoTotal
                  | currency : "" : "symbol" : "1.2-2"
              }}
            </div>
          </div>

          <hr class="salary-divider" />

          <div class="salary-row salary-row-vertical">
            <div class="salary-label-center">Saldo Comprobado</div>
            <div class="salary-amount-center">
              {{
                DatosColaborador?.saldoUtilizado
                  | currency : "" : "symbol" : "1.2-2"
              }}
            </div>
          </div>

          <div class="salary-row salary-row-vertical">
            <div class="salary-label-center">Saldo Pendiente</div>
            <div class="salary-amount-center">
              {{
                DatosColaborador?.saldoRestante
                  | currency : "" : "symbol" : "1.2-2"
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="salary-card" *ngIf="DatosColaborador?.saldoRestanteGestante != undefined && DatosColaborador?.saldoUtilizadoGestante != undefined && DatosColaborador?.saldoTotalGestante != undefined">
      <div class="salary-table">
        <div class="salary-row salary-row-total salary-row-vertical">
          <div class="salary-label-total">Saldo Total Gestante</div>
          <div class="salary-amount-total">
            {{
              (DatosColaborador?.saldoTotalGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>

        <hr class="salary-divider" />

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Comprobado Gestante</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoUtilizadoGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>

        <div class="salary-row salary-row-vertical">
          <div class="salary-label-center">Saldo Pendiente Gestante</div>
          <div class="salary-amount-center">
            {{
              (DatosColaborador?.saldoRestanteGestante | currency : '' : 'symbol' : '1.2-2') || "-"
            }}
          </div>
        </div>
      </div>
      <div class="leyenda-container">
      <span class="leyenda-texto">La Vigencia de saldo de bebés en gestación es de 9 meses a partir de su Fecha de Alta</span>
      </div>
    </div>
    </div>
  </ng-template>
</div>
</nz-spin>

<nz-spin [nzSpinning]="isLoadingBeneficiarios" nzTip="Cargando..." class="loading-spinner">
  <div class="boton-añadir-container" *ngIf="(this.user?.esColaborador) && !tieneGestante()">
  <button
    *ngIf="NoAcceso"
    nz-button
    nzType="primary"
    class="excel-button boton-añadir"
    (click)="AddBeneficiario()"
  >
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    Añadir Solicitud de Bebé Gestante
  </button>
</div>
<div class="center-container scroll-container">
  <nz-table
    class="tabla-principal"
    #basicTable
    [nzData]="beneficiarios"
    [nzShowPagination]="true"
  >
    <thead>
      <tr>
        <th class="table-header-bold">Beneficiario</th>
        <th class="table-header-bold">Fecha de Nacimiento</th>
        <th class="table-header-bold">Fecha de Alta del Beneficio</th>
        <th class="table-header-bold">Parentesco</th>
        <th class="table-header-bold">Saldo Asignado</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="tieneGestante()">
          <ng-container>
            <td colspan="4">
            <div class="center-container">
              <div class="gestante-tag">
                <i
                  nz-icon
                  nzType="info-circle"
                  nzTheme="outline"
                  style="margin-right: 8px"
                ></i>
                <span>Tienes un beneficio de gestante activo</span>
              </div>
            </div>
          </td>
          <td>{{ obtenerSaldoGestante() | currency : "MXN" : "symbol" : "1.2-2" }}
        </ng-container>

      </tr>
      <tr *ngFor="let item of basicTable.data">
        <ng-container *ngIf="!item.esGestante; else TemplateGestante">
          <td>{{ item?.nombres }} {{ item?.apellidos }}</td>
          <td>{{ (item?.fechaNacimiento | date : "dd/MM/yyyy") || "N/A" }}</td>
          <td>{{ (item?.fechaAltaGmm | date : "dd/MM/yyyy") || "N/A" }}</td>
          <td>{{ item?.parentescoNombre }}</td>
          <td>{{ item?.saldoTotal | currency : "MXN" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>
        <ng-template #TemplateGestante>
          <ng-container *ngIf="mostrarInfo(item?.parentescoNombre)">
          <td>{{ item?.nombres }} {{ item?.apellidos }}</td>
          <td>{{ (item?.fechaNacimiento | date : "dd/MM/yyyy") || "N/A" }}</td>
          <td>{{ (item?.fechaAltaGmm | date : "dd/MM/yyyy") || "N/A" }}</td>
          <td>{{ item?.parentescoNombre }}</td>
          <td>{{ item?.saldo | currency : "MXN" : "symbol" : "1.2-2" }}
          </td>
          </ng-container>
        </ng-template>
      </tr>
    </tbody>
  </nz-table>
</div>
  <div class="center-container-label">
    <span class="leyenda-texto" style="align-items: right;">Saldo Asignado = Cantidad x UMA</span>
  </div>
</nz-spin>
    


<nz-spin [nzSpinning]="isLoadingHistogram" nzTip="Cargando..." class="loading-spinner">



<div class="center-container scroll-container">
  <div class="chart-section-full">
    <div class="chart-background">
      <h3 class="chart-title">Histograma</h3>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="simpleChartData"
          [options]="simpleChartOptions"
          [type]="'bar'"
          width="1200"
          height="400"
        ></canvas>
      </div>
    </div>
  </div>
</div>

<!-- Tabla resumen debajo del gráfico (100% ancho) -->
<div class="center-container scroll-container">
  <div class="table-section-full">
    <div class="table-wrapper-full">
      <nz-table
        [nzData]="resumenSaldos"
        [nzScroll]="{ x: '800px' }"
        nzSize="small"
        [nzShowPagination]="true"
      >
        <thead>
          <tr>
            <th
              class="table-header-bold"
              style="width: 120px; min-width: 120px"
            >
              Periodo
            </th>
            <th class="table-header-bold">Ene</th>
            <th class="table-header-bold">Feb</th>
            <th class="table-header-bold">Mar</th>
            <th class="table-header-bold">Abr</th>
            <th class="table-header-bold">May</th>
            <th class="table-header-bold">Jun</th>
            <th class="table-header-bold">Jul</th>
            <th class="table-header-bold">Ago</th>
            <th class="table-header-bold">Sep</th>
            <th class="table-header-bold">Oct</th>
            <th class="table-header-bold">Nov</th>
            <th class="table-header-bold">Dic</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fila of resumenSaldos">
            <td>
              <strong class="size">{{ fila.concepto }}</strong>
            </td>
            <td>{{ fila.enero }}</td>
            <td>{{ fila.febrero }}</td>
            <td>{{ fila.marzo }}</td>
            <td>{{ fila.abril }}</td>
            <td>{{ fila.mayo }}</td>
            <td>{{ fila.junio }}</td>
            <td>{{ fila.julio }}</td>
            <td>{{ fila.agosto }}</td>
            <td>{{ fila.septiembre }}</td>
            <td>{{ fila.octubre }}</td>
            <td>{{ fila.noviembre }}</td>
            <td>{{ fila.diciembre }}</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
</nz-spin>